// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3v0EF","Layout__Message":"Layout_Layout__Message__1oasM"};